import * as React from "react";

export function OpenDashDefaultRoute(params: any) {
  return <span>404</span>;
}
